import React, {useEffect, useState} from 'react';
import { deleteClosedSession } from '../../../../../../../../../../crud/management_api/local_sessions';
import { Button, Modal, Spinner } from 'react-bootstrap'
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import StateSummary from 'views/Base/components/NavBar/components/SessionInfo/components/EndSession/components/StateSummary/StateSummary';
import './DeleteSession.scss';


interface DeleteSessionProps {
    show: boolean;
    onClose: () => void;
    localSessionId: number | null;
    onDeleteSuccess: () => void;
}

const DeleteSession: React.FC<DeleteSessionProps> = ({ show, onClose, localSessionId, onDeleteSuccess }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [acknowledged, setAcknowledged] = useState(false);

        useEffect(() => {
                // Reset ack when modal opens/closes or id changes
                setAcknowledged(false);
                // Hide acknowledgment until we attempt to load the summary for a valid id
                if (show && localSessionId) {
                    setSummaryLoading(true);
                } else {
                    setSummaryLoading(false);
                }
        }, [show, localSessionId]);

    const handleDelete = async () => {
        if (!localSessionId) return;
        try {
            setIsDeleting(true);
            await deleteClosedSession(localSessionId);
            toast.success('Sesión eliminada correctamente');
            onDeleteSuccess();
            onClose();
        } catch (e) {
            toast.error('No se pudo eliminar la sesión');
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered scrollable dialogClassName="delete-session-modal">
            <Modal.Header>
                <div className='form-modal-title-container'>
                    <Modal.Title className='form-modal-title'>Eliminar sesión</Modal.Title>
                </div>
                <Button variant="none" onClick={onClose}>
                    <X size={24} />
                </Button>
            </Modal.Header>
            <Modal.Body>
                <p>¿Estás seguro de que deseas eliminar esta sesión? Esta acción no se puede deshacer.</p>
                                <StateSummary
                                    show={true}
                                    localSessionId={localSessionId}
                                    onLoadingChange={setSummaryLoading}
                                />
                {!summaryLoading && (
                    <label className="skip-checkbox" style={{ marginTop: '0.5rem' }}>
                        <input
                            type="checkbox"
                            checked={acknowledged}
                            onChange={(e) => setAcknowledged(e.target.checked)}
                            disabled={isDeleting}
                        />
                        <span>
                            Certifico que he leído y entiendo que estos datos serán eliminados y que no podré recuperarlos
                        </span>
                    </label>
                )}
            </Modal.Body>
            <Modal.Footer>
                <div className="form-modal-footer-custom">
                    <Button variant='none' className="form-button-cancel" onClick={onClose} disabled={isDeleting}>
                        Cancelar
                    </Button>
                                        <Button
                        variant='none'
                        className="form-button-create"
                        onClick={handleDelete}
                        disabled={isDeleting || summaryLoading || !acknowledged}
                    >
                                                {isDeleting && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className="me-2"
                                                    />
                                                )}
                                                {isDeleting ? 'Eliminando…' : 'Eliminar'}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteSession;